import React, { useState, useEffect } from 'react';
import { firestore, auth } from '../../firebase/config';
import { collection, getDocs, doc, updateDoc } from 'firebase/firestore';
import { sendPasswordResetEmail } from 'firebase/auth';
import CriarUsuarioModal from './CriarUsuarioModal';
import EditarUsuarioModal from './EditarUsuarioModal';
import './GerenciarUsuarios.css';

function GerenciarUsuarios({ user }) {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const fetchUsuarios = async () => {
    setLoading(true);
    try {
      const usersCollection = collection(firestore, 'usuarios');
      const usersSnapshot = await getDocs(usersCollection);
      const usersList = usersSnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setUsuarios(usersList);
    } catch (err) {
      console.error("Erro ao buscar usuários:", err);
      setError("Não foi possível carregar a lista de usuários.");
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUsuarios();
  }, []);

  const toggleStatus = async (usuarioId, statusAtual) => {
    try {
      const novoStatus = statusAtual === 'inativo' ? 'ativo' : 'inativo';
      const userRef = doc(firestore, 'usuarios', usuarioId);
      await updateDoc(userRef, { status: novoStatus });
      setSuccess(`Status atualizado para ${novoStatus} com sucesso!`);
      fetchUsuarios(); // Recarrega a lista
    } catch (err) {
      console.error("Erro ao atualizar status:", err);
      setError("Erro ao atualizar o status do usuário.");
    }
  };

  const redefinirSenha = async (email) => {
    if(window.confirm(`Tem certeza que deseja enviar um email de redefinição de senha para ${email}?`)) {
      try {
        await sendPasswordResetEmail(auth, email);
        setSuccess(`Email de redefinição enviado para ${email}.`);
      } catch (err) {
        console.error("Erro ao enviar email de redefinição:", err);
        setError("Erro ao enviar email de redefinição.");
      }
    }
  };

  if (loading) {
    return <div>Carregando usuários...</div>;
  }

  const filteredUsuarios = usuarios.filter(u => {
    const term = searchTerm.toLowerCase();
    return (
      (u.nome && u.nome.toLowerCase().includes(term)) ||
      (u.email && u.email.toLowerCase().includes(term)) ||
      (u.perfil && u.perfil.toLowerCase().includes(term))
    );
  });

  return (
    <div className="gerenciar-usuarios-container">
      <h2>Gerenciar Usuários</h2>
      
      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      <div className="usuarios-actions">
        <input 
          type="text" 
          placeholder="Buscar usuário (nome, email, perfil)..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <button className="btn-primary" onClick={() => setShowModal(true)}>
          + Novo Usuário
        </button>
      </div>

      <table className="usuarios-table">
        <thead>
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Perfil</th>
            <th>Status</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {filteredUsuarios.map(u => (
            <tr key={u.id} className={u.status === 'inativo' ? 'row-inativo' : ''}>
              <td>{u.nome || '-'}</td>
              <td>{u.email}</td>
              <td className="perfil-cell">{u.perfil}</td>
              <td>
                <span className={`status-badge ${u.status === 'inativo' ? 'status-inativo' : 'status-ativo'}`}>
                  {u.status === 'inativo' ? 'Inativo' : 'Ativo'}
                </span>
              </td>
              <td className="actions-cell">
                <button 
                  className="btn-editar"
                  onClick={() => setEditingUser(u)}
                >
                  Editar
                </button>
                <button 
                  className={u.status === 'inativo' ? 'btn-ativar' : 'btn-inativar'}
                  onClick={() => toggleStatus(u.id, u.status)}
                >
                  {u.status === 'inativo' ? 'Ativar' : 'Desativar'}
                </button>
                <button 
                  className="btn-redefinir"
                  onClick={() => redefinirSenha(u.email)}
                >
                  Redefinir Senha
                </button>
              </td>
            </tr>
          ))}
          {filteredUsuarios.length === 0 && (
            <tr>
              <td colSpan="5" className="text-center">Nenhum usuário encontrado.</td>
            </tr>
          )}
        </tbody>
      </table>

      {showModal && (
        <CriarUsuarioModal 
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            setSuccess("Usuário criado com sucesso!");
            fetchUsuarios();
          }}
        />
      )}

      {editingUser && (
        <EditarUsuarioModal
          usuario={editingUser}
          onClose={() => setEditingUser(null)}
          onSuccess={() => {
            setEditingUser(null);
            setSuccess("Usuário atualizado com sucesso!");
            fetchUsuarios();
          }}
        />
      )}
    </div>
  );
}

export default GerenciarUsuarios;
